import { AxiosHeaders, AxiosResponse } from 'axios';

import { REFRESH_TOKEN_ENDPOINT } from '../../constants/token-endpoints.const';
import { WebStoreApiRefreshTokensRequestBody } from '../../models';
import { WebStoreTokenResponse } from '../../models/webstore-token-response';
import { getTokenFromHeaders } from '../../utilities/get-token-from-headers';
import { webStoreHttp } from '../web-store-api';

export const fetchRefreshedToken = async (
  body: WebStoreApiRefreshTokensRequestBody,
  headers: AxiosHeaders
): Promise<WebStoreTokenResponse> => {
  const response = await webStoreHttp.post<
    WebStoreApiRefreshTokensRequestBody,
    AxiosResponse<WebStoreTokenResponse>
  >(`/${REFRESH_TOKEN_ENDPOINT}`, body, { headers });
  response.data.token = getTokenFromHeaders(response.headers);
  return response.data;
};
